var map = {
	"./finger.png": 64,
	"./finger@2x.png": 65,
	"./finger@3x.png": 66
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;



//////////////////
// WEBPACK FOOTER
// ./img/finger ^\.\/finger.*\.png$
// module id = 182
// module chunks = 3